import React from "react";
import NavBar from "../components/NavBar";
import TitleCard from "../components/TitleCard";
import AsiaTeam from "../screens/AsiaTeam";
import Footer from "../components/Footer";

const AsgSouthAsia = () => {
  return (
    <>
      <NavBar />
      <TitleCard
        heading="ASG South Asia"
        subHeading="Passionate Experts Driving Animal Conservation Excellence"
      />
      <AsiaTeam />
      <Footer />
    </>
  );
};

export default AsgSouthAsia;
